export default __webpack_public_path__ + "static/media/aboutimg.9688bce6.png";